import { Heading } from '@/components/heading';
import {
  ROUTE_SORT_TYPE_CO2,
  ROUTE_SORT_TYPE_COMPLEXITY,
  ROUTE_SORT_TYPE_DISTANCE,
  ROUTE_SORT_TYPE_DURATION,
  ROUTE_SORT_TYPE_FREQUENCY,
  ROUTE_SORT_TYPE_MATCH,
} from '@/lib/constants';
import { RouteModel } from '@/lib/models/route/types';
import { RouteSortTypes } from '@/types';
import { XenetaRatesFieldApiType } from '@/types/api-types';
import { tv } from '@/utils/styles';

import { RouteSearchResultRow } from '../search-result-row';
import { RouteSortOptions } from '../sort-options';

export interface RouteSearchResultHeroProps {
  route: RouteModel;
  sortValue: RouteSortTypes;
  isLocked?: boolean;
  ratesAreLocked?: boolean;
  canSaveRates?: boolean;
  rateFields?: XenetaRatesFieldApiType;
  onRouteClick: (route: RouteModel) => void;
  onDetailsClick: (route: RouteModel) => void;
  onSortingChange: (value: RouteSortTypes) => void;
}

const getHeroTitle = (sortBy: RouteSortTypes) => {
  switch (sortBy) {
    case ROUTE_SORT_TYPE_MATCH:
      return 'Best matched route';
    case ROUTE_SORT_TYPE_DURATION:
      return 'Fastest cargo route';
    case ROUTE_SORT_TYPE_COMPLEXITY:
      return 'Most direct route';
    case ROUTE_SORT_TYPE_DISTANCE:
      return 'Shortest overall distance';
    case ROUTE_SORT_TYPE_FREQUENCY:
      return 'Most frequent departures';
    case ROUTE_SORT_TYPE_CO2:
      return 'Lowest emissions route';
    default:
      return 'Top route result';
  }
};

const RouteSearchResultHero = ({
  route,
  sortValue,
  isLocked,
  ratesAreLocked,
  canSaveRates,
  rateFields,
  onRouteClick,
  onDetailsClick,
  onSortingChange,
}: RouteSearchResultHeroProps) => {
  const { base, header } = styles();

  return (
    <div className={base()}>
      <div className={header()}>
        {!isLocked && <RouteSortOptions sortValue={sortValue} onSortingChange={onSortingChange} />}
        <Heading variant="h4" as="h2" className="mb-0 text-base text-text-primary">
          {getHeroTitle(sortValue)}
        </Heading>
      </div>
      <RouteSearchResultRow
        route={route}
        index={0}
        isHero
        onRouteClick={onRouteClick}
        onDetailsClick={onDetailsClick}
        isLocked={isLocked}
        ratesAreLocked={ratesAreLocked}
        canSaveRates={canSaveRates}
        rateFields={rateFields}
      />
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'mb-6',
    header: 'mb-2 flex items-center justify-start gap-2',
  },
});

export { RouteSearchResultHero };
